module.exports = __webpack_public_path__ + "assets/img/231b6bcdd8b5b8226fd4cd531d425260.svg";